<template>
  <el-form
      ref="form"
      :model="form">
    <el-row type="flex" class="gj-picker" style="height: 440px;">

<!--      左边-->
      <div class="gj-picker__editor" style="height: 440px;">
        <el-tabs :value="'first'">

<!--          搜索-->
          <el-tab-pane label="搜索" name="first">
            <div>

<!--              输入框-->
              <div class="gj-picker__editor--header">
                <gj-input
                    v-model="keyword"
                    :placeholder="placeholderStr"
                    size="medium"
                    width="100%"
                    class="gj-picker__editor--header--input">
                  <template #append>
                    <gj-button
                        type="iconfont"
                        iconfont="iconsousuo1"
                        @click="search"
                    ></gj-button>
                  </template>
                </gj-input>
              </div>

<!--              排序框-->
              <div class="flex align-center" style="height: 40px;border-bottom: 1px solid #d9d9d9;box-sizing: border-box;padding-left: 12px;">
                排序：
                <gj-select
                    v-model="sortType"
                    :options="[
                      {id: '0', text: '最新创建'},
                      {id: '1', text: '最早创建'},
                      {id: '2', text: '优选广告商品'},
                    ]"
                    :width="'120px'"
                    :clearable="false"
                    style="margin: 0 8px 0 12px;"
                ></gj-select>
                <gj-help>
                  最新创建：按照商品的创建日期倒序排列，最新在最先。<br>
                  最早创建：按照商品的创建日期顺序排列，最新在最后。<br>
                  优选广告商品：按照最有可能吸引消费者的商品进行排序，如果投放广告，则更有可能产生点击。
                </gj-help>
              </div>

<!--              表格框-->
              <div class="gj-picker__editor--body">

<!--                最新、最早创建 接口动态分页-->
                <gj-table
                    v-show="sortType !== '2'"
                    :index="false"
                    :adapt-height="false"
                    :height="278"
                    :data="tableData"
                    stripe
                    :border="false"
                    :loading="loading"
                    :columns="columns0"
                    :pagination="pagination1"
                    :page-sizes = "[20, 50, 100]"
                    :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                    @page-change="$gjQuery">
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllItem(tableData)"
                    >添加全部</gj-button>
                  </template>
                  <template v-slot:imageUrl="{ row }">
                    <gj-image :src="row.imageUrl" style="margin-left: 6px;"></gj-image>

                    <gj-tooltip v-if="row.eligibilityStatus==='INELIGIBLE'">
                      <template #content>
                        <div class="gj-tooltip-content">
                          <div style="font-size: 13px;font-weight: 600;">不符合条件的商品</div>
                          <div class="size12">该商品不能推广，因为：</div>
                          <div class="flex" style="align-items: baseline" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                            <span class="content-reason"></span>
                            <span>{{s}}</span>
                          </div>
                        </div>
                      </template>
                      <gj-tag :color="tagColors.redDark" class="flex align-center justify-center img-tag">
                        <i class="iconfont icontishixiangqing"></i>
                        不符合
                      </gj-tag>
                    </gj-tooltip>

                    <gj-tooltip v-if="row.eligibilityStatus==='ELIGIBLE_WITH_WARNING'">
                      <template #content>
                        <div class="gj-tooltip-content">
                          <div style="font-size: 13px;font-weight: 600;">广告可能已暂停</div>
                          <div class="size12">可能无法获取展示，因为：</div>
                          <div class="flex" style="align-items: baseline;" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                            <span class="content-reason"></span>
                            <span>{{s}}</span>
                          </div>
                        </div>
                      </template>
                      <gj-tag :color="tagColors.orangeDark" class="flex align-center justify-center img-tag">
                        <i class="iconfont icontishixiangqing"></i>
                        警告
                      </gj-tag>
                    </gj-tooltip>

                  </template>
                  <template v-slot:listingTitle="{ row }">
                    <div style="margin: 4px 0;">
                      <gj-tooltip
                          :text-line="1"
                          :content="row.listingTitle">
                        {{row.listingTitle | defaultShow}}
                      </gj-tooltip>
<!--                      <el-row-->
<!--                          v-if="false"-->
<!--                          type="flex"-->
<!--                          align="middle"-->
<!--                          v-gutter="8">-->
<!--                        <el-rate-->
<!--                            :value="row.star"-->
<!--                            disabled-->
<!--                            style="display: inline;"-->
<!--                            text-color="#ff9900">-->
<!--                        </el-rate>-->
<!--                        <span>({{row.star}})</span>-->
<!--                        <el-divider direction="vertical"></el-divider>-->
<!--                        <span style="color: #CC0000">${{row.price | defaultShow}}</span>-->
<!--                      </el-row>-->
                      <div class="flex align-center size12" style="padding: 4px 0;">
                        <div class="flex align-center" :class="{'colorRed':AdWarnEnum[row.availability].name==='缺货'}" style="width: 90px;" v-if="row.availability">
                          {{AdWarnEnum[row.availability].name}}
                          <gj-help style="margin-left: 4px;" v-if="AdWarnEnum[row.availability].text">{{AdWarnEnum[row.availability].text}}</gj-help>
                        </div>
                        <div>
                          <span class="colorRed">{{row.priceToPay | defaultShow(row.currencySymbol)}}</span>
                          <span class="color999 strikethrough" style="margin-left: 12px;position: relative" v-if="row.priceToPay!==row.basisPrice">{{row.basisPrice | defaultShow(row.currencySymbol,'','')}}</span>
                        </div>
                      </div>
                      <el-row>
                        <el-col :span="10">
                          <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
                        </el-col>
                        <el-col :span="14" style="display: flex;">
                          <span style="font-weight: 600;">MSKU：</span>
                          <span class="msku-class" :title="row.msku">{{row.msku | defaultShow}}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <template v-if="isMeaningless(row.exitAds) || row.exitAds === 0">
                      <gj-button
                          v-if="row.eligibilityStatus === 'ELIGIBLE'||row.eligibilityStatus === 'ELIGIBLE_WITH_WARNING'"
                              size="mini"
                              type="ghost"
                              :disabled="row.btnDisabled"
                              style="padding: 5px 15px;"
                              @click="addItem(index, row)"
                      >添加</gj-button>
                      <gj-button
                              v-if="isMeaningful(row.variationList)&&row.variationList.length>0"
                              type="text"
                              :disabled="row.btnDisabled"
                              :loading="row.variationAsinLoading"
                              style="margin-left: 4px;"
                              @click="addVariationItem(index, row)"
                      >添加变体</gj-button>
                    </template>
                    <template v-else>
                      <gj-button
                              size="mini"
                              type="text"
                              disabled
                              style="margin-left: 4px;"
                      >已添加</gj-button>
                    </template>
                  </template>
                </gj-table>

<!--                优选广告商品 本地静态分页-->
                <gj-table
                    v-show="sortType === '2'"
                    tableType="static"
                    :index="false"
                    :adapt-height="false"
                    :height="278"
                    :data="preferTableData"
                    stripe
                    :border="false"
                    :loading="loading"
                    :columns="columns0"
                    :pagination="pagination2"
                    :page-sizes = "[20, 50, 100]"
                    :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                    @static-page-change="getStaticData">
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllItem(staticData)"
                    >添加全部</gj-button>
                  </template>
                  <template v-slot:imageUrl="{ row }">
                    <gj-image :src="row.imageUrl" style="margin-left: 6px;"></gj-image>

                    <gj-tooltip content="123" v-if="row.eligibilityStatus==='INELIGIBLE'">
                      <template #content>
                        <div class="gj-tooltip-content">
                          <div style="font-size: 13px;font-weight: 600;">不符合条件的商品</div>
                          <div class="size12">该商品不能推广，因为：</div>
                          <div class="flex" style="align-items: baseline" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                            <span class="content-reason"></span>
                            <span>{{s}}</span>
                          </div>
                        </div>
                      </template>
                      <gj-tag :color="tagColors.redDark" class="flex align-center justify-center img-tag">
                        <i class="iconfont icontishixiangqing"></i>
                        不符合
                      </gj-tag>
                    </gj-tooltip>

                    <gj-tooltip v-if="row.eligibilityStatus==='ELIGIBLE_WITH_WARNING'">
                      <template #content>
                        <div class="gj-tooltip-content">
                          <div style="font-size: 13px;font-weight: 600;">广告可能已暂停</div>
                          <div class="size12">可能无法获取展示，因为：</div>
                          <div class="flex" style="align-items: baseline;" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                            <span class="content-reason"></span>
                            <span>{{s}}</span>
                          </div>
                        </div>
                      </template>
                      <gj-tag :color="tagColors.orangeDark" class="flex align-center justify-center img-tag">
                        <i class="iconfont icontishixiangqing"></i>
                        警告
                      </gj-tag>
                    </gj-tooltip>

                  </template>
                  <template v-slot:listingTitle="{ row }">
                    <div style="margin: 4px 0;">
                      <gj-tooltip
                          :text-line="1"
                          :content="row.listingTitle">
                        {{row.listingTitle | defaultShow}}
                      </gj-tooltip>
                      <!--                      <el-row-->
                      <!--                          v-if="false"-->
                      <!--                          type="flex"-->
                      <!--                          align="middle"-->
                      <!--                          v-gutter="8">-->
                      <!--                        <el-rate-->
                      <!--                            :value="row.star"-->
                      <!--                            disabled-->
                      <!--                            style="display: inline;"-->
                      <!--                            text-color="#ff9900">-->
                      <!--                        </el-rate>-->
                      <!--                        <span>({{row.star}})</span>-->
                      <!--                        <el-divider direction="vertical"></el-divider>-->
                      <!--                        <span style="color: #CC0000">${{row.price | defaultShow}}</span>-->
                      <!--                      </el-row>-->
                      <div class="flex align-center size12" style="padding: 4px 0;">
                        <div class="flex align-center" :class="{'colorRed':AdWarnEnum[row.availability].name==='缺货'}" style="width: 90px;" v-if="row.availability">
                          {{AdWarnEnum[row.availability].name}}
                          <gj-help style="margin-left: 4px;" v-if="AdWarnEnum[row.availability].text">{{AdWarnEnum[row.availability].text}}</gj-help>
                        </div>
                        <div>
                          <span class="colorRed">{{row.priceToPay | defaultShow(row.currencySymbol)}}</span>
                          <span class="color999 strikethrough" style="margin-left: 12px;position: relative" v-if="row.priceToPay!==row.basisPrice">{{row.basisPrice | defaultShow(row.currencySymbol,'','')}}</span>
                        </div>
                      </div>
                      <el-row>
                        <el-col :span="10">
                          <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
                        </el-col>
                        <el-col :span="14" style="display: flex;">
                          <span style="font-weight: 600;">MSKU：</span>
                          <span class="msku-class" :title="row.msku">{{row.msku | defaultShow}}</span>
                        </el-col>
                      </el-row>
                    </div>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <template v-if="isMeaningless(row.exitAds) || row.exitAds === 0">
                      <gj-button
                          v-if="row.eligibilityStatus === 'ELIGIBLE'||row.eligibilityStatus === 'ELIGIBLE_WITH_WARNING'"
                          size="mini"
                          type="ghost"
                          :disabled="row.btnDisabled"
                          style="padding: 5px 15px;"
                          @click="addItem(index, row)"
                      >添加</gj-button>
                      <gj-button
                          v-if="isMeaningful(row.variationList)&&row.variationList.length>0"
                          type="text"
                          :disabled="row.btnDisabled"
                          :loading="row.variationAsinLoading"
                          style="margin-left: 4px;"
                          @click="addVariationItem(index, row)"
                      >添加变体</gj-button>
                    </template>
                    <template v-else>
                      <gj-button
                          size="mini"
                          type="text"
                          disabled
                          style="margin-left: 4px;"
                      >已添加</gj-button>
                    </template>
                  </template>
                </gj-table>

              </div>

            </div>
          </el-tab-pane>

<!--          输入-->
          <el-tab-pane label="输入" name="input">
            <div style="margin: 10px 12px 0;">

              <div style="margin-bottom: 10px;">
                <gj-textarea
                    v-model="inputText"
                    :styles="{
                      'border-color': this.errorKeyword ? '#F56C6C' : '',
                      fontSize: '12px',
                      ...textareaStyles
                    }"
                    resize="none"
                    placeholder="请输入ASIN，一行一个，回车换行">
                </gj-textarea>
              </div>

              <el-row
                  type="flex"
                  align="middle"
                  justify="space-between"
                  class="gj-picker__editor--footer">
                <span :class="{red: errorKeyword}">ASIN不得包含特殊字符，如@、#、*和$等</span>
                <gj-button
                    type="primary"
                    @click="addByInput"
                    :disabled="!isMeaningful(inputText)"
                    :loading="loadingInput"
                >添加</gj-button>
              </el-row>

              <div style="margin-top: 10px">
                <gj-alert v-if="alert.error && alert.error.length !== 0" ref="gjAlert" type="error" show-icon closable @close="closeError">
                  <template #title>
                    <div>{{ `成功${alert.success.length || 0}个，失败${alert.error.length || 0}个` }}</div>
                    <div class="alert-error">{{ `失败原因： ASIN在店铺中不存在/不符合广告添加条件/ASIN重复添加，失败的ASIN：${alert.error.join('，')}` }}</div>
                  </template>
                </gj-alert>
                <gj-alert v-else ref="gjAlert" type="success" show-icon closable @close="closeError">
                  <template #title>
                    <div class="alert-content">{{ `${alert.success.length || 0}个ASIN全部添加成功` }}</div>
                  </template>
                </gj-alert>
              </div>

            </div>
          </el-tab-pane>

        </el-tabs>
      </div>

<!--      右边-->
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            ref="gjTable"
            name="adAddKeyword"
            :index="false"
            :show-pagination="false"
            :border="false"
            :adapt-height="false"
            :height="398"
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:imageUrl="{ row }">
            <gj-image :src="row.imageUrl" style="margin-left: 6px;"></gj-image>
            <gj-tooltip content="123" v-if="row.eligibilityStatus==='INELIGIBLE'">
              <template #content>
                <div class="gj-tooltip-content">
                  <div style="font-size: 13px;font-weight: 600;">不符合条件的商品</div>
                  <div class="size12">该商品不能推广，因为：</div>
                  <div class="flex" style="align-items: baseline;" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                    <span class="content-reason"></span>
                    <span>{{s}}</span>
                  </div>
                </div>
              </template>
              <gj-tag :color="tagColors.redDark" class="flex align-center justify-center img-tag">
                <i class="iconfont icontishixiangqing"></i>
                不符合
              </gj-tag>
            </gj-tooltip>

            <gj-tooltip v-if="row.eligibilityStatus==='ELIGIBLE_WITH_WARNING'">
              <template #content>
                <div class="gj-tooltip-content">
                  <div style="font-size: 13px;font-weight: 600;">广告可能已暂停</div>
                  <div class="size12">可能无法获取展示，因为：</div>
                  <div class="flex" style="align-items: baseline;" v-for="(s,index) in row.ineligibilityReasons" :key="index">
                    <span class="content-reason"></span>
                    <span>{{s}}</span>
                  </div>
                </div>
              </template>
              <gj-tag :color="tagColors.orangeDark" class="flex align-center justify-center img-tag">
                <i class="iconfont icontishixiangqing"></i>
                警告
              </gj-tag>
            </gj-tooltip>
          </template>
          <template v-slot:listingTitle="{ row }">
            <div style="margin: 4px 0;">
              <gj-tooltip
                  :text-line="1"
                  :content="row.listingTitle">
                {{row.listingTitle | defaultShow}}
              </gj-tooltip>
<!--              <el-row-->
<!--                  v-if="false"-->
<!--                  type="flex"-->
<!--                  align="middle"-->
<!--                  v-gutter="8">-->
<!--                <el-rate-->
<!--                    :value="row.star"-->
<!--                    disabled-->
<!--                    style="display: inline;"-->
<!--                    text-color="#ff9900">-->
<!--                </el-rate>-->
<!--                <span>({{row.star}})</span>-->
<!--                <el-divider direction="vertical"></el-divider>-->
<!--                <span style="color: #CC0000">${{row.price | defaultShow}}</span>-->
<!--              </el-row>-->
              <div class="flex align-center size12" style="padding: 4px 0;">
                <div class="flex align-center" :class="{'colorRed':AdWarnEnum[row.availability].name==='缺货'}" style="width: 90px;" v-if="row.availability">
                  {{AdWarnEnum[row.availability].name}}
                  <gj-help style="margin-left: 4px;" v-if="AdWarnEnum[row.availability].text">{{AdWarnEnum[row.availability].text}}</gj-help>
                </div>
                <div>
                  <span class="colorRed">{{row.priceToPay | defaultShow(row.currencySymbol)}}</span>
                  <span class="color999 strikethrough" style="margin-left: 12px;position: relative" v-if="row.priceToPay!==row.basisPrice">{{row.basisPrice | defaultShow(row.currencySymbol,'','')}}</span>
                </div>
              </div>
              <el-row>
                <el-col :span="10">
                  <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
                </el-col>
                <el-col :span="14"  style="display: flex;">
                  <span style="font-weight: 600;">MSKU：</span>
                  <span class="msku-class" :title="row.msku">{{row.msku | defaultShow}}</span>
                </el-col>
              </el-row>
            </div>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>

    </el-row>

    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import {formMixin, isMeaningfulMixin, queryMixin, isMeaninglessMixin} from "@/minxins";
  import {isMeaningful, isMeaningless, unique} from "@/utils/common";
  import {getItemsPage,eligibility} from "@/api/ad";
  import {AdTypeEnum, AdWarnEnum} from "@/views/modules/ad/common/enum";
  import { tagColors } from "@/components/tag/tag-colors";

  export default {
    name: "app-product-picker",
    mixins: [isMeaningfulMixin, formMixin, queryMixin, isMeaninglessMixin],
    props: {
      title: {
        required: true,
      },
      marketId: {
        required: true
      },
      groupRequired: {
        type: Boolean,
        default: false,
      },
      groupId: {
        default: null,
      },
      baseInfoForm: {
        default: null,
      }
    },
    created() {
      this.columns[0].header = this.title;
    },
    data() {
      return {
        AdWarnEnum,
        tagColors,
        placeholderStr:'按商品标题、ASIN、MSKU编码搜索',
        inputText: null,
        tableData: [],//搜索--最新、最早排序  表格数据
        preferTableData:[],//搜索--优选排序  表格数据  用于本地分页
        staticData:[],// 本地分页,当前页数据
        keyword: null,//搜索输入框值
        sortType:'0',//排序选中值
        loadingInput: false,
        textareaStyles: {
          height: '340px'
        },
        alert: { // 错误提示
          success: [],
          asins: [],
        },
        columns0: [
          {id: 'picture', header: '图片', field: 'slot:imageUrl', width: '65px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:listingTitle', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '100'},
        ],
        columns: [
          {id: 'picture', header: '图片', field: 'slot:imageUrl', width: '65px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:listingTitle', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        //动态分页
        pagination1: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        //静态分页
        pagination2: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        // 静态分页时，已请求过状态的页码
        currentPages:[],
        isMeaningful: isMeaningful
      }
    },
    watch: {
      groupId: {
        handler(groupId) {
          if (isMeaningful(groupId)) {
            // groupId变化时，清空 记录的 已获取状态的 静态分页的 页码
            this.currentPages = [];
            this.pagination2.currentPage = 1;
            this.$gjQuery();
          }
         }
      },
      // 排序选项改变
      sortType:{
        handler(n,o){
          if(n === '2'){
            this.keyword = '';
            this.placeholderStr = '按ASIN搜索';
            this.currentPages = [];
            //排序变为优选排序，数据为空时才请求数据
            // if(this.preferTableData.length === 0){
              this.$gjQuery();
            // }
          }else {
            if(o === '2'){
              this.keyword = '';
            }
            this.pagination1.currentPage = 1;
            this.placeholderStr = '按商品标题、ASIN、MSKU编码搜索';
            this.$gjQuery();
          }
        }
      }
    },
    computed: {
      errorKeyword() {
        return !/^[^!#%<>@*$]*$/.test(this.inputText)
      }
    },
    methods: {
      search(){
        if(this.sortType === '2'){
          this.currentPages = []
        }
        this.$gjNoticeQuery()
      },
      // 关闭
      closeError() {
        setTimeout(() => {
          this.textareaStyles.height = '340px';
        }, 300);
      },
      //添加输入框的asin
      async addByInput() {
        this.loadingInput = true
        this.alert.success = [];
        this.alert.error = [];
        //输入的asin列表
        const asinList = this.inputText.split('\n').map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, ''));
        //用于请求的asin列表
        const asinListFilter = [];
        let items = this.form.items.map(e => e.asin);
        asinList.forEach(element => {
          let str = element.toUpperCase()
          let rule = /^[B|b]0[A-Za-z0-9]{8}$/.test(str);
          if (rule && !asinListFilter.includes(str) && !items.includes(str)) {
            //符合验证规则且不重复的asin 才放入用于请求的列表中
            asinListFilter.push(str);
          }else {
            //否则 放入失败asin列表中
            this.alert.error.push(element);
          }
        });
        // const asinListFilter = asinList.filter(item => isMeaningful(item) && !/\n+/.test(item));
        // const params = {
        //   marketId: this.marketId,
        //   campaignId: this.baseInfoForm ? this.baseInfoForm.campaignId : null,
        //   groupId: this.baseInfoForm ? this.baseInfoForm.groupId : null,
        //   adsType: 0,
        //   asinList: asinListFilter
        // }
        const params = {
          model: {
            adType: AdTypeEnum.SP,// 广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
            marketId: this.marketId,// 站点id
            asinList:asinListFilter
          },
          current: 1,
          size: 9999
        }
        try {
          // 请求数据
          let  {records:data}  = await getItemsPage(params)
          if(data.length>0){
            // 根据数据,获取数据状态
            await this.getEligibility(data)
          }
          // 若返回的数据结果，小于请求的asin列表长度
          if(data.length < asinListFilter.length){
            // 遍历数据结果，找出缺少的asin
            let dataMap = data.map(e => e.asin)
            this.alert.error = this.alert.error.concat(asinListFilter.filter(r => dataMap.indexOf(r)< 0))
          }

          // 遍历数据结果
          data.forEach(res => {
            // 若数据状态为不符合'INELIGIBLE'，为失败
            if(res.eligibilityStatus==='INELIGIBLE'){
              this.alert.error.push(res.asin)
            }else {
              this.alert.success.push(res.asin)
            }
          })
          // let dataMap = data.map(e => e.asin).filter(e => !items.includes(e));
          // 设置错误信息
          // this.alert.success = data.length;
          // this.alert.error = asinList.filter(e => {
          //   const index = dataMap.indexOf(e);
          //   if (index === -1) return e;
          //   dataMap.splice(index , 1);
          // })
          this.textareaStyles.height = '240px';
          this.$refs.gjAlert.$refs.alert.visible = true;

          // 添加
          this.addAllItem(data.map(e => ({ ...e, listingTitle: e.title })));
          this.inputText = "";
        } catch (error) {
          //
        } finally {
          this.loadingInput = false
        }
      },
      //静态翻页时，接收当前页的数据
      async getStaticData(data){
        this.staticData = data;
        // 若当前分页未请求过状态,则请求状态
        if(this.currentPages.indexOf(this.pagination2.currentPage) === -1){
          this.loading = true;
          try {
            await this.getEligibility(this.preferTableData,data)
          }
          finally {
            this.loading = false;
          }
        }
      },
      //获取列表数据
      $gjQuery() {
        if (this.groupRequired && isMeaningless(this.groupId)) {
          return;
        }
        // 构造查询参数
        let params = {
          model: {
            adType: AdTypeEnum.SP,// 广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
            keyword: this.keyword,// 搜索词
            marketId: this.marketId,// 站点id
            sortType: this.sortType// 排序方式 ------ **枚举值**: `0`: 最新创建 `1`: 最早创建 `2`: 优选广告商品
          },
          ...this.querySort
        };
        if(this.sortType === '2'){
          params = {
            ...params,
            current: this.pagination2.currentPage,
            size: this.pagination2.pageSize
          }
        }
        else{
          params = {
            ...params,
            current: this.pagination1.currentPage,
            size: this.pagination1.pageSize
          }
        }
        // 查询
        this.loading = true;
        getItemsPage(params)
          .then((data) => {
            if (isMeaningful(data) && isMeaningful(data.records)) {
              // 优选商品排序  静态分页
              if(this.sortType === '2'){
                this.preferTableData = data.records.map(e => ({
                  ...e,
                  listingTitle: e.title
                }));
                this.pagination2.total = this.preferTableData.length;
              }
              //最新 最早排序  动态分页
              else {
                this.tableData = data.records.map(e => ({
                  ...e,
                  listingTitle: e.title
                }));
                this.pagination1 = this.getPagination(data);
                this.getEligibility(this.tableData)
              }
            } else {
              if(this.sortType === '2'){
                this.preferTableData = [];
              }else {
                this.tableData = [];
              }
            }
            this.refreshBtnDisable();
          })
          .complete(() => this.loading = false);
      },
      //通过列表获取状态等
      async getEligibility(tableData,data){
        //tableData 表格数据    data 用于请求的数据
        if(tableData.length === 0) return
        let params = {
          adType:AdTypeEnum.SP,//广告类型 ------ **枚举值**: `0`: 商品广告 `1`: 品牌广告 `2`: 展示广告
          marketId:this.marketId
        }
        //
        if(isMeaningful(data)){
          params.asinList = data.map(r => {
            return {
              asin:r.asin,
              msku:r.msku
            }
          })
        }else {
          params.asinList = tableData.map(r => {
            return {
              asin:r.asin,
              msku:r.msku
            }
          })
        }
        await eligibility(params).then(res => {
          if(res){
            //若静态分页，请求状态成功，记录已请求页
            if(data){
              this.currentPages.push(this.pagination2.currentPage)
            }

            tableData.forEach(r => {
              Object.assign(r,res.find(d => d.asin === r.asin&&d.msku === r.msku))
            })
          }
        })
      },
      //添加全部
      addAllItem(items) {
        // 添加全部时，过滤状态为不符合的数据
        this.form.items = unique([].concat(this.form.items).concat(items.filter(r => r.eligibilityStatus !== 'INELIGIBLE')), 'msku');
        this.refreshBtnDisable();
      },
      //添加
      addItem(index, row) {
        this.form.items = unique([].concat(this.form.items).concat([row]), 'msku');
        this.refreshBtnDisable();
      },
      //刷新按钮状态
      refreshBtnDisable() {
        if(this.sortType === '2'){
          this.preferTableData.forEach(e1 => {
            if (this.form.items.some(e2 => e1.msku === e2.msku)) {
              this.$set(e1, 'btnDisabled', true);
            } else {
              this.$set(e1, 'btnDisabled', false);
            }
          });
        }else {
          this.tableData.forEach(e1 => {
            if (this.form.items.some(e2 => e1.msku === e2.msku)) {
              this.$set(e1, 'btnDisabled', true);
            } else {
              this.$set(e1, 'btnDisabled', false);
            }
          });
        }
      },
      //添加变体
      addVariationItem(index, row) {
        this.$set(row, 'variationAsinLoading', true);
        getItemsPage({
          model: {
            adType: AdTypeEnum.SP,
            marketId: this.marketId,
            asinList: row.variationList
          },
          current: 1,
          size: 999999
        })
          .then(async (data) => {
            await this.getEligibility(data.records)
            if (isMeaningful(data) && isMeaningful(data.records)) {
              this.addAllItem(data.records.map(e => ({
                ...e,
                listingTitle: e.title
              })));
            }
          })
          .complete(() => this.$set(row, 'variationAsinLoading', false));
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          if (this.form.items.length <= 0) {
            this.$gjMessage.closeAll();
            this.$gjMessage.error('请添加商品');
            reject();
          } else {
            this.$refs.form.validate(valid => {
              valid ? resolve() : reject()
            });
          } 
        })
      }
    },
    mounted () {
      this.$refs.gjAlert.$refs.alert.visible = false;
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  .alert-error {
    white-space: normal;
    max-height: 51px;
    overflow: auto;
  }
  .gj-picker__editor {
    width: 50%;
    padding: 0;
  }
  .gj-picker__table {
    width: 50%;
  }
  .alert-content {
    max-height: 60px;
    overflow: auto;
    padding-right: 9px;
    margin-right: -6px;
  }
  /deep/.el-tabs__header {
    margin-bottom: 0 !important;
  }
  /deep/ .el-input-group__append {
    border-radius: 0;
    border: none;
    min-width: 40px;
  }
  /deep/ .el-pagination .btn-prev {
    padding-right: 3px;
  }
  /deep/ .el-pagination .btn-next {
    padding-left: 3px;
  }
  /deep/ .el-pagination__total {
    margin-right: 2px;
  }
  /deep/ .footer__pagination {
    margin-right: 0;
    padding: 7px 16px !important;
  }
  /deep/ .el-pagination {
    padding-right: 0;
  }
  /deep/ .el-pagination .el-select .el-input {
    width: 90px;
  }
  /deep/ .gj-picker__table--title{
    height: 19px;
  }
  .msku-class {
    width: 137px;
    display: inline-block;
    overflow: hidden;/*超出部分隐藏*/
    text-overflow:ellipsis;/* 超出部分显示省略号 */
    white-space: nowrap;/*规定段落中的文本不进行换行 */
  }
  .strikethrough::after{
    content: '';
    width: 100%;
    height: 1px;
    position: absolute;
    left: 0;
    top:50%;
    border-bottom: 1px solid #979797;
  }
  .img-tag{
    border-radius: 2px;
    padding: 0;
    height: 18px;
    width: 54px;
    .icontishixiangqing{
      font-size: 12px;
      margin-right: 2px;
    }
  }
  .gj-tooltip-content{
    div+div{
      margin-top: 8px;
      line-height: 19px;
    }
    .content-reason{
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: white;
      margin-right: 8px;
      flex: none;
    }
  }
</style>

